<div id='topnav' #topnav>
    <div class='inner'>
        <div class='logo'>
            <a [routerLink]='"/dashboard"'><img src='assets/img/loop_plus_lobster_2024.svg' /></a>
        </div>
        <a (click)='menu.toggle($event)' class='userinfo' href='javascript: void(0);'>
            <ng-container i18n='@@Hello'>Hallo,</ng-container>
            {{ user?.firstname }} <i class='fa-regular fa-bars'></i></a>
    </div>
</div>
<p-menu #menu [model]='dropdownMenu' [popup]='true' [appendTo]='topnav' [styleClass]='"main-menu"'></p-menu>


